















import { Vue, Component, Watch } from 'vue-property-decorator'
import { Getter, Mutation } from 'vuex-class'
import { PaymentType } from '@/api/models/PaymentType'
import PaymentTypes from '@/shared/views/PaymentTypes.vue'
import AccountService from '@/api/services/AccountService'
import Account from '@/api/models/Account'
import { RootStateMutations } from '@/store/mutations'

const accountService = new AccountService()

@Component({
    components: {
        PaymentTypes
    }
})

export default class PaymentTypesBase extends Vue {
    private error = ''

    @Getter('currentAccount')
    private currentAccount: Account

    private systemPaymentTypes: Array<PaymentType> = []

    @Mutation(RootStateMutations.setLoading)
    private setLoading: (state: boolean) => void

    @Watch('currentAccount')
    changeCurrentAccount() {
        this.loadPaymentTypes()
    }

    async created(): Promise<void> {
        await this.loadPaymentTypes()
    }

    async loadPaymentTypes(): Promise<void> {
        this.clearError()
        this.setLoading(true)

        try {
            if (this.currentAccount?.id) {
                this.systemPaymentTypes = await accountService.getPaymentTypes(this.currentAccount.id)
            }
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.paymentTypes.getPaymentTypesError').toString()
        } finally {
            this.setLoading(false)
        }
    }

    async updatePaymentType(paymentType: PaymentType) {
        this.clearError()
        this.setLoading(true)

        try {
            if (this.currentAccount?.id) {
                await accountService.updatePaymentTypes(this.currentAccount.id, paymentType)
            }
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.paymentTypes.error').toString()
        } finally {
            this.setLoading(false)
        }
    }

    clearError() {
        this.error = ''
    }
}
